export default __webpack_public_path__ + "static/media/features_header.ee39babd.png";